import React from 'react';
import { HelpModal as HelpModalBase } from 'react-design-components';
import { useHelpModal } from './hooks';

const HelpModal: React.FC = ({ children }) => {
  const { visible, dispatchHelpModalVisibility } = useHelpModal();

  return (
    <HelpModalBase visible={visible} toggleHelpModal={dispatchHelpModalVisibility}>
      {children}
    </HelpModalBase>
  );
};

export default HelpModal;
